import { useEffect, useRef, useState } from 'react'

type UsePolling = <T, U>(
    callback: (vars?: U) => Promise<T>,
    delay: number | null,
) => void

export const usePolling: UsePolling = (callback, delay) => {
    const callbackRef = useRef<typeof callback | null>(null)
    const [resetInterval, setResetInterval] = useState<boolean>(false)

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    useEffect(() => {
        const tick = async () => {
            if (callbackRef.current) {
                await callbackRef.current()
                setResetInterval((prev) => !prev)
            }
        }
        if (delay !== null) {
            let id = setTimeout(tick, delay)
            return () => clearInterval(id)
        }
    }, [delay, resetInterval])
}